<div class="list_container me-2">
  <div class="mt-2 ms-3 me-3 mb-4">
    <div class="deals_container">
      <!-- Deal listing  starts here -->

      <div class="deals_sub_container">
        <ng-container *ngIf="stepInput.dsp == 'adsp'">
          <span class="warning_message me-2">
            <ol style="margin-bottom: 0px">
              <li>
                Deal selection is mandatory for 'Private Auction' and 'Prime'
                LI-Deal type. Select atleast one deal.
              </li>
              <li>
                Deals are listed based on the max cpm, start date and end date
                of the line item. Adjust these values in Basic Set up section to
                see available deals.
              </li>
            </ol>
          </span>
        </ng-container>

        <!-- Deal listing search box -->
        <div class="flex_row_space_between mt-3 mb-3">
          <div class="flex_row">
            <mat-form-field
              style="height: 35px"
              class="no-padding search-input-shadow"
              appearance="outline"
            >
              <input
                matInput
                class="placeholders"
                [(ngModel)]="dealsSearchTerm"
                (keyup)="searchDeals()"
                placeholder="Search"
                #input
              />
              <mat-icon matSuffix class="material-icons search_icon">
                search
              </mat-icon>
            </mat-form-field>
          </div>

          <div class="flex_row" *ngIf="stepInput.dsp == 'bdsp'">
            <mat-form-field
              style="width: 100%"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label>Seller</mat-label>
              <mat-select
                [(ngModel)]="selectedSeller"
                (ngModelChange)="sellerSelectionChange()"
                placeholder="Seller"
                [multiple]="false"
                #multiSelect
              >
                <mat-option>
                  <ngx-mat-select-search
                    (keyup)="searchSellers($event.target.value)"
                    [placeholderLabel]="'search sellers...'"
                    [noEntriesFoundLabel]="'Not found'"
                  >
                  </ngx-mat-select-search>
                </mat-option>

                <mat-option
                  style="color: black"
                  class="green-checkbox"
                  value="all"
                  >All</mat-option
                >
                <mat-option
                  style="color: black"
                  class="green-checkbox"
                  *ngFor="let item of dealSellers"
                  [value]="item.key"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>

        <div
          [ngClass]="{
            'mt-3': stepInput.dsp == 'adsp'
          }"
        >
          <table
            [ngClass]="{
              deals_table: stepInput.dsp == 'adsp'
            }"
            #dealsSort="matSort"
            mat-table
            [dataSource]="dealsDataSource"
            matSort
          >
            <ng-container matColumnDef="checkbox">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [ngClass]="{ deal_checkbox: stepInput.dsp == 'adsp' }"
              ></th>
              <td
                mat-cell
                *matCellDef="let row"
                [ngClass]="{ deal_checkbox: stepInput.dsp == 'adsp' }"
              >
                <label class="checkbox-container">
                  <input type="checkbox" (click)="addDeals(row)" />
                  <span class="checkboxmark"></span>
                </label>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">ID</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.id }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="tdsp_id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">Deal Macro ID</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name lowercase">{{ row.tdsp_id }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="deal_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">Name</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.name }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="deal_name"
              >
                <span class="table_header_name"> Name </span>
              </th>
              <td mat-cell *matCellDef="let row" class="deal_name">
                <span
                  class="table_value_name cursor_pointer"
                  (click)="showViewDeatails(row)"
                  >{{ row.name }}</span
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">Status</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.state }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="start_date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Deal Validity Period </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <p class="table_value_name">
                  {{
                    row.start_date ? (row.start_date.split(" ")[0] | date) : "_"
                  }}
                  <span style="text-transform: lowercase"
                    >{{ row.end_date ? "to" : "" }}
                  </span>
                </p>
                <p class="table_value_name">
                  {{ row.end_date ? (row.end_date.split(" ")[0] | date) : "" }}
                </p>
              </td>
            </ng-container>

            <ng-container matColumnDef="seller.name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Seller Name
              </th>
              <td mat-cell *matCellDef="let row">
                <span>{{row.seller.name}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">
                  <ng-container
                    *ngIf="
                      stepInput.dsp == 'vdsp' || stepInput.dsp == 'bdsp' || stepInput.dsp == 'tdsp';
                      else adsp
                    "
                  >
                    Price ({{ stepInput.clientCurrency }})
                  </ng-container>
                  <ng-template #adsp> Price </ng-template>
                </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <ng-container
                  *ngIf="
                    stepInput.dsp == 'vdsp' || stepInput.dsp == 'bdsp' || stepInput.dsp == 'tdsp' ;
                    else adsp
                  "
                >
                  <span class="table_value_name">{{
                    row.price | toFixed : 2 | number : "1.2-2"
                  }}</span>
                </ng-container>
                <ng-template #adsp>
                  <p class="table_value_name">
                    {{
                      row.price
                        | currency : row.currency : "symbol" : "1.2-2" : "en"
                    }}
                  </p>
                  <p class="table_value_name">
                    <b>Type: </b
                    >{{ row.price_type.split("_").join(" ") | titlecase }}
                  </p>
                </ng-template>
              </td>
            </ng-container>

            <ng-container matColumnDef="seller.name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">Seller</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.seller.name }}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsDeals"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumnsDeals"
            ></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data available</td>
            </tr>
          </table>

          <mat-paginator
            #dealsPaginator
            [pageSizeOptions]="[10, 25, 100]"
            (page)="handlePageEvent($event)"
            [length]="dealsCount"
          >
          </mat-paginator>
        </div>
      </div>
      <!-- Deal listing ends here -->

      <mat-divider [vertical]="true"></mat-divider>

      <!-- Selected Deals starts here -->

      <div class="deals_sub_container">
        <ng-container *ngIf="stepInput.dsp == 'vdsp'">
          <div class="ms-1 selected-deals-msg">
            <p
              class="warning_message tooltip-class me-3"
              *ngIf="inactiveDealIDS.length > 0"
            >
              Deals {{ inactiveDealIDS }} have expired and are no longer
              available for targeting. Kindly remove or replace them
            </p>
            <p class="warning_message tooltip-class me-3">
              Deal selection is mandatory.
              <ng-container
                *ngIf="
                  pgDealTypeOptions.includes(ioDealType) ||
                  ioDealType == 'pmp_netflix'
                "
              >
                Only one Deal can be targeted if the IO type is
                {{ ioDealTypeMapping[ioDealType] }}
              </ng-container>
            </p>
          </div>
        </ng-container>
        <ng-container *ngIf="stepInput.dsp == 'bdsp'">
          <div class="ms-1 selected-deals-msg">
            <p class="warning_message tooltip-class me-3">
              Deal selection is mandatory.
              <ng-container *ngIf="ioDealType == 'pg'">
                The targeting action will only be "Include" for "PG" LI.
                Deals targeted should be from the same seller.
              </ng-container>
            </p>
          </div>
        </ng-container>

        <ng-container *ngIf="stepInput.dsp == 'tdsp'">
          <div class="ms-1 selected-deals-msg">
            <p class="warning_message tooltip-class me-3">
              Deal selection is mandatory.
            </p>
          </div>
        </ng-container>

        <div class="deals_selected_table">
          <table
            [ngClass]="{
              deals_table: stepInput.dsp == 'adsp'
            }"
            #dealsSortSelected="matSort"
            mat-table
            [dataSource]="selectedDealsDataSource"
            matSort
          >
            <ng-container matColumnDef="checkbox">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [ngClass]="{ deal_checkbox: stepInput.dsp == 'adsp' }"
              ></th>
              <td
                mat-cell
                *matCellDef="let row"
                [ngClass]="{ deal_checkbox: stepInput.dsp == 'adsp' }"
              >
                <label
                  class="checkbox-container"
                  *ngIf="stepInput.dsp != 'bdsp'"
                >
                  <input type="checkbox" checked (click)="removeDeals(row)" />
                  <span class="checkboxmark"></span>
                </label>
                <ng-container *ngIf="stepInput.dsp == 'bdsp'">
                  <span
                    matTooltip="Select to INCLUDE in targeting"
                    [ngClass]="{
                      'material-icons': true,
                      'include-icon': row.deal_action === 'exclude',
                      'include-icon-selected': row.deal_action === 'include'
                    }"
                    (click)="row.deal_action = 'include'"
                  >
                    check
                  </span>

                  <span
                    *ngIf="ioDealType == 'pmp'"
                    matTooltip="Select to EXCLUDE from targeting"
                    [ngClass]="{
                      'material-icons': true,
                      'exclude-icon': row.deal_action === 'include',
                      'exclude-icon-selected': row.deal_action === 'exclude'
                    }"
                    (click)="row.deal_action = 'exclude'"
                  >
                    block
                  </span>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">ID</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.id }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="deal_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">Name</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name"> {{ row.name }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="deal_name"
              >
                <span class="table_header_name"> Name </span>
              </th>
              <td mat-cell *matCellDef="let row" class="deal_name">
                <span class="table_value_name">{{ row.name }}</span>
                <p class="table_value_name mt-1">
                  <i
                    ><b>Deal Type: </b
                    >{{ row.deal_type.split("_").join(" ") }}</i
                  >
                </p>
              </td>
            </ng-container>

            <ng-container matColumnDef="start_date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Deal Validity Period </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <p class="table_value_name">
                  {{
                    row.start_date ? (row.start_date.split(" ")[0] | date) : "_"
                  }}
                  <span style="text-transform: lowercase"
                    >{{ row.end_date ? "to" : "" }}
                  </span>
                </p>
                <p class="table_value_name">
                  {{ row.end_date ? (row.end_date.split(" ")[0] | date) : "" }}
                </p>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">Status</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.state }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="tdsp_id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">Deal Macro ID</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name lowercase">{{ row.tdsp_id }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">
                  <ng-container
                    *ngIf="
                      stepInput.dsp == 'vdsp' || stepInput.dsp == 'bdsp' || stepInput.dsp == 'tdsp' ;
                      else adsp
                    "
                  >
                    Price ({{ stepInput.clientCurrency }})
                  </ng-container>
                  <ng-template #adsp> Price </ng-template>
                </span>
              </th>
              <td mat-cell *matCellDef="let row">
                <ng-container
                  *ngIf="
                    stepInput.dsp == 'vdsp' || stepInput.dsp == 'bdsp' || stepInput.dsp == 'tdsp';
                    else adsp
                  "
                >
                  <span class="table_value_name">{{
                    row.price | toFixed : 2 | number : "1.2-2"
                  }}</span>
                </ng-container>
                <ng-template #adsp>
                  <p class="table_value_name">
                    {{
                      row.price
                        | currency : row.currency : "symbol" : "1.2-2" : "en"
                    }}
                  </p>
                  <p class="table_value_name">
                    <b>Type: </b
                    >{{ row.price_type.split("_").join(" ") | titlecase }}
                  </p>
                </ng-template>
              </td>
            </ng-container>

            <ng-container matColumnDef="seller.name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name">Status</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name">{{ row.seller.name }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="remove">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"></span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span
                  class="material-icons ml-3"
                  style="cursor: pointer; color: gray"
                  (click)="removeDeals(row)"
                >
                  cancel
                </span>
                <!-- <span class="table_value_name">{{ row.seller_key }}</span> -->
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="selectedDealColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: selectedDealColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data available</td>
            </tr>
          </table>
          <mat-paginator
            #dealsPaginatorSelected
            [pageSizeOptions]="[5, 10, 25, 100]"
          >
          </mat-paginator>
        </div>
      </div>
      <!-- Selected Deals starts here -->
    </div>
  </div>
</div>
